if (!window.mainCollectionDrawerCloseBound) {
  window.mainCollectionDrawerCloseBound = true;

  document.addEventListener(
    'click',
    function (event) {
      var closeTrigger = event.target.closest('[data-main-collection-close]');
      if (!closeTrigger) return;

      var drawer = closeTrigger.closest('.main-collection__drawer');
      if (!drawer) return;

      event.preventDefault();
      drawer.removeAttribute('open');
    },
    true
  );
}

document.addEventListener('DOMContentLoaded', function () {
  var filterRequestController = null;

  function debounce(callback, wait) {
    var timeout;

    return function () {
      var args = arguments;
      window.clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        callback.apply(null, args);
      }, wait);
    };
  }

  function getMainCollection() {
    return document.querySelector('[data-main-collection]');
  }

  function getSectionId() {
    var productGrid = document.getElementById('product-grid');
    return productGrid ? productGrid.dataset.id : null;
  }

  function createSearchParams(form) {
    var params = new URLSearchParams();
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      if (value !== '') {
        params.append(key, value);
      }
    });

    return params.toString();
  }

  function renderCollection(searchParams, updateUrl) {
    var sectionId = getSectionId();
    var currentSection = getMainCollection();

    if (!sectionId || !currentSection) return;

    if (filterRequestController) {
      filterRequestController.abort();
    }

    filterRequestController = new AbortController();
    currentSection.setAttribute('aria-busy', 'true');

    var sectionUrl = window.location.pathname + '?section_id=' + sectionId;
    if (searchParams) {
      sectionUrl += '&' + searchParams;
    }

    fetch(sectionUrl, { signal: filterRequestController.signal })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        var nextSection = parsedDocument.querySelector('[data-main-collection]');

        if (!nextSection) return;

        currentSection.innerHTML = nextSection.innerHTML;

        if (updateUrl !== false) {
          var nextUrl = window.location.pathname + (searchParams ? '?' + searchParams : '');
          window.history.pushState({ searchParams: searchParams }, '', nextUrl);
        }

        bindMainCollectionEvents();
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') {
          console.error('Error filtering collection:', error);
        }
      })
      .finally(function () {
        var section = getMainCollection();
        if (section) {
          section.removeAttribute('aria-busy');
        }
      });
  }

  var debouncedRenderCollection = debounce(function (form) {
    renderCollection(createSearchParams(form));
  }, 800);

  function bindProductBadgeScroll() {
    document.querySelectorAll('.product-badges__list--scroll').forEach(function (list) {
      if (list.dataset.badgeScrollBound === 'true') return;
      list.dataset.badgeScrollBound = 'true';

      var startX = 0;
      var startY = 0;
      var isDragging = false;

      list.addEventListener(
        'touchstart',
        function (event) {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          isDragging = false;
        },
        { passive: true }
      );

      list.addEventListener(
        'touchmove',
        function (event) {
          if (list.scrollWidth <= list.clientWidth) return;

          var deltaX = Math.abs(event.touches[0].clientX - startX);
          var deltaY = Math.abs(event.touches[0].clientY - startY);

          if (deltaX > deltaY && deltaX > 4) {
            isDragging = true;
            event.stopPropagation();
          }
        },
        { passive: true }
      );

      list.addEventListener('click', function (event) {
        if (isDragging) {
          event.preventDefault();
          event.stopPropagation();
          isDragging = false;
        }
      });
    });
  }

  function bindMainCollectionEvents() {
    document.querySelectorAll('[data-main-collection-sort] select').forEach(function (select) {
      if (select.dataset.mainCollectionBound === 'true') return;
      select.dataset.mainCollectionBound = 'true';

      select.addEventListener('change', function () {
        renderCollection(createSearchParams(select.form));
      });
    });

    document.querySelectorAll('[data-main-collection-filters]').forEach(function (form) {
      if (form.dataset.mainCollectionBound === 'true') return;
      form.dataset.mainCollectionBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        renderCollection(createSearchParams(form));
      });

      form.addEventListener('change', function (event) {
        if (form.hasAttribute('data-main-collection-mobile-filters')) {
          return;
        }

        if (event.target.matches('input[type="number"]')) {
          debouncedRenderCollection(form);
          return;
        }

        renderCollection(createSearchParams(form));
      });

      form.addEventListener('input', function (event) {
        if (form.hasAttribute('data-main-collection-mobile-filters')) {
          return;
        }

        if (event.target.matches('input[type="number"]')) {
          debouncedRenderCollection(form);
        }
      });

      form.querySelectorAll('details').forEach(function (detailsEl) {
        var summary = detailsEl.querySelector('summary.filter-values-summary');
        if (!(detailsEl instanceof HTMLDetailsElement)) return;
        if (!(summary instanceof HTMLElement) || summary.parentElement !== detailsEl) return;

        detailsEl.addEventListener('toggle', function () {
          if (!detailsEl.open) return;
          form.querySelectorAll('details').forEach(function (other) {
            if (other === detailsEl) return;
            if (!other.querySelector('summary.filter-values-summary')) return;
            other.open = false;
          });
        });
      });
    });

    document.querySelectorAll('[data-main-collection-apply]').forEach(function (button) {
      if (button.dataset.mainCollectionBound === 'true') return;
      button.dataset.mainCollectionBound = 'true';

      button.addEventListener('click', function () {
        var drawer = button.closest('.main-collection__drawer');
        var form = drawer ? drawer.querySelector('[data-main-collection-mobile-filters]') : null;

        if (form) {
          renderCollection(createSearchParams(form));
        }

        if (drawer) {
          drawer.removeAttribute('open');
        }
      });
    });

    document.querySelectorAll('[data-main-collection-filter-link]').forEach(function (link) {
      if (link.dataset.mainCollectionBound === 'true') return;
      link.dataset.mainCollectionBound = 'true';

      link.addEventListener('click', function (event) {
        var url = new URL(link.href, window.location.origin);

        if (url.pathname !== window.location.pathname) return;

        event.preventDefault();
        renderCollection(url.search.slice(1));
      });
    });

    document.querySelectorAll('[data-main-collection-close]').forEach(function (button) {
      if (button.dataset.mainCollectionBound === 'true') return;
      button.dataset.mainCollectionBound = 'true';

      button.addEventListener('click', function () {
        var drawer = button.closest('details');
        if (drawer) drawer.removeAttribute('open');
      });
    });

    document.querySelectorAll('[data-main-collection-quick-add]').forEach(function (form) {
      if (form.dataset.mainCollectionBound === 'true') return;
      form.dataset.mainCollectionBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var button = form.querySelector('button[type="submit"]');
        if (button) {
          button.disabled = true;
          button.dataset.originalText = button.textContent;
          button.textContent = 'Adding...';
        }

        fetch(form.action + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw response;
            return response.json();
          })
          .then(function (data) {
            if (window.globalEvents) {
              window.globalEvents.emit('cart.add', data);
              window.globalEvents.emit('notice.global', {
                type: 'success',
                content: window.GM_STATE && window.GM_STATE.cart ? window.GM_STATE.cart.itemAdded : 'Item added to cart'
              });
            }

            return fetch('/cart.js');
          })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            if (window.globalEvents) {
              window.globalEvents.emit('cart.count', cart.item_count);
            }
          })
          .catch(function () {
            if (window.globalEvents) {
              window.globalEvents.emit('notice.global', {
                type: 'error',
                content: 'Error adding item to cart. Please try again.'
              });
            }
          })
          .finally(function () {
            if (button) {
              button.disabled = false;
              button.textContent = button.dataset.originalText || 'Add to cart';
            }
          });
      });
    });

    bindProductBadgeScroll();
  }

  window.addEventListener('popstate', function (event) {
    var searchParams = event.state && event.state.searchParams ? event.state.searchParams : window.location.search.slice(1);
    renderCollection(searchParams, false);
  });

  bindMainCollectionEvents();
});